module.exports = __webpack_public_path__ + "img/three-four.1c53ac40.png";